(function() {
  angular.module('registration')
  .controller('changeCredentialController', ['$scope','$log','secLoginResource','UserProfile','asyncYamlLoader','$state','$cookies','$window','$rootScope',
    'secSecurityService',
  function($scope, $log, loginResource,UserProfile,asyncYamlLoader,$state,$cookies,$window,$rootScope,secSecurityService) {
    var vm = this;
    vm.reset = reset;
    vm.submit = submit;
    vm.verifyPassword=loginUser;
    vm.challengeResponseChanged=false;
    vm.inUserView = true;
    vm.applicationName = $rootScope.applicationName;
    
    secSecurityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
      vm.inUserView = val;
    });
    initialize();

    asyncYamlLoader().then(function(data) {
      if (!vm.securityQuestions) {
    	vm.securityQuestions = [];
      }
      Array.prototype.push.apply(vm.securityQuestions, data.content.registration.securityQuestions);
    });	
    
    $scope.$watch('errorControl', function() {
      $scope.errorControl && $scope.errorControl.showErrors('invalidPassword');
    });

    function initModel() {
      vm.model = {};
      vm.confNewPassword = '';
      vm.model.newPassword = '';
      vm.model.challengeResponses = vm.user && vm.user.challengeResponses ? angular.copy(vm.user.challengeResponses) : [{},{},{}];
    }

    function initialize(){
      UserProfile.get((data) => {
        vm.user = data;
        initModel();
      });
    }

    function loginUser(){
      secSecurityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        if (val || !vm.model.currentPassword) return;
        UserProfile.validatePassword({password: vm.model.currentPassword}, function(response) {
          $scope.changeCredentialForm.currentPassword.$setValidity('invalidPassword', response.valid);
        });
      });
    }

    function inputChanged() {
      vm.challengeResponseChanged = false;
      _.each(vm.model.challengeResponses, (challengeResponse, index) => {
          if (!(challengeResponse.challenge.toUpperCase() === vm.user.challengeResponses[index].challenge.toUpperCase() &&
                challengeResponse.response.toUpperCase() === vm.user.challengeResponses[index].response.toUpperCase())) {
                vm.challengeResponseChanged =true;
          }
      });
      return  (vm.model.newPassword ||  vm.challengeResponseChanged);
    }

    function reset() {
      $scope.errorControl.showErrors('invalidPassword');
      initModel();
      $scope.changeCredentialForm.currentPassword.$setValidity('invalidPassword', true);
      $scope.changeCredentialForm.confNewPassword.$setValidity('match',true);
      $scope.changeCredentialForm.$setPristine();
      $($window).scrollTop(0);
      $window.document.getElementById('currentPassword').focus();
    }

    function submit(){
      $scope.errorControl.showErrors();
      $scope.changeCredentialForm.confNewPassword.$setValidity('match', vm.model.newPassword === vm.confNewPassword);
      if ($scope.changeCredentialForm.$valid && inputChanged()) {
        vm.saving = true;
        UserProfile.update(vm.model, (data) =>{
          if (data.message) {
            if (vm.model.newPassword) {
                vm.model.currentPassword = vm.model.newPassword;
                loginUser();
            }
            if (vm.challengeResponseChanged) {
              vm.user.challengeResponses=angular.copy(vm.model.challengeResponses);
              _.each(vm.user.challengeResponses, (challengeResponse) => {
                  challengeResponse.response="";
              });
            }
            reset();
            $scope.dnConfirmationMessage.$show(data.message);
          }
          vm.saving = false;
        },(error) => {
          vm.saving = false;
        });
      }
    }

  }]);
})();
